










export default {
  props: {
    hSpan: { type: Number, default: 1, validator: prop => prop > 0 && prop <= 24 },
    vSpan: { type: Number, default: 2, validator: prop => prop > 0 && prop <= 3 }
  }
}
